import { Box, Typography } from '@mui/material'
import { FC } from 'react'

export const ContainerHeader: FC = () => {
  return (
    <Box>
      <Typography
        variant='h4'
        fontSize={{ xs: '32px', md: '40px' }}
        sx={{mt:2}}
        color="text.primary"
        textAlign="center"
      >
        Input Results
      </Typography>

      <Typography
        fontSize={{ xs: '14px', md: '16px' }}
        fontWeight={500}
        color="#475569"
        textAlign="center"
        maxWidth="600px"
        sx={{ mt: { xs: 2, md: 3 }, mx: 'auto' }}
      >
        Use the provided template to match the color on the strip to the closest results for each attributes. When done, submit for analysis.
      </Typography>
    </Box>
  )
}
